var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromotionalCopy72(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 36,
    fill: "#FFF6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.7071 30.0861C43.8354 30.0861 47.8653 30.8878 47.8653 34.8964C47.8653 38.9051 43.8354 39.7068 42.7071 39.7068M42.7071 22.0688L32.3906 29.1953C22.0742 29.1953 22.0742 28.4826 22.0742 35.6982C22.0742 35.6982 22.0742 35.6982 22.0742 35.6982C22.0742 35.6982 22.0742 37.0304 22.0742 38.5972C22.0742 39.7018 22.9697 40.5976 24.0742 40.5976H32.3906C36.4195 43.3806 42.7071 47.724 42.7071 47.724V22.0688Z",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.746 48.4054V40.7847H26.9102V48.4054C26.9102 49.5099 27.8056 50.4054 28.9102 50.4054H29.746C30.8505 50.4054 31.746 49.5099 31.746 48.4054Z",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9257 34.8965H51.0898",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.898 25.2763L49.4785 28.6777",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.898 44.7115L49.4785 41.3101",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7461 41.3106V30.0864",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionalCopy72);
export default __webpack_public_path__ + "static/media/promotional-copy-72.406ae270.svg";
export { ForwardRef as ReactComponent };